export default __webpack_public_path__ + "static/media/mundito.60686aaa.png";